import React, { useState } from 'react'
import Modal from '../modal/modal'
import Button from '@mui/material/Button'
import { DialogActions } from '@mui/material';

export default function BulkAllocationModal(props) {
  const {
    selectedCount,
    onApprove,
    onDelete,
    onReject,
    onCancel,
    open,
    dialogClose
  } = props;

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [actionType, setActionType] = useState(null);

  const handleActionClick = (type) => {
    // For approve and reject, go directly to comment modal (no confirmation needed)
    // For delete, show confirmation modal (no comment needed)
    if (type === 'approve' || type === 'reject') {
      if (type === 'approve') {
        onApprove();
      } else if (type === 'reject') {
        onReject();
      }
    } else if (type === 'delete') {
      setActionType(type);
      setShowConfirmModal(true);
    }
  };

  const handleConfirm = () => {
    setShowConfirmModal(false);
    // Only delete goes through confirmation
    if (actionType === 'delete') {
      onDelete();
    }
  };

  return (
    <>
      <Modal
        open={open}
        onClose={dialogClose}
        fullWidth={true}
        maxWidth='md'
        modalHeading="Bulk Actions"
        showActionBtn
      >
        <p>{selectedCount} Timesheet records selected</p>

        <DialogActions className='actionbtn'>
          <div className='actionbtn'>
            <Button variant='contained' className="cancel-btn" onClick={() => handleActionClick('approve')} color='primary'>
              Accept/Approve
            </Button>
            <Button variant='contained' className="cancel-btn" onClick={() => handleActionClick('delete')} color='error'>
              Delete
            </Button>
            <Button variant='contained' className="cancel-btn" onClick={() => handleActionClick('reject')} color='warning'>
              Reject
            </Button>
            <Button variant='contained' className="cancel-btn" onClick={onCancel} color=''>
              Cancel
            </Button>
          </div>
        </DialogActions>
      </Modal>
      <Modal
        open={showConfirmModal}
        onClose={() => setShowConfirmModal(false)}
        fullWidth={true}
        maxWidth='sm'
        modalHeading={`Confirm ${actionType} Action`}
        modalSaveTxt='Yes'
        modalCloseTxt='No'
        onClick={handleConfirm}
        showActionBtn
        savebtnClass='createBtn'
        cxlbtnClass='cancelBtn'
        primary
      >
        <p>Are you sure you want to perform this {actionType} action?</p>
      </Modal>
    </>
  );
}
